import { createReducer } from '@reduxjs/toolkit';
import * as assetsActions from '../actions/assets.action';
import { constants as config } from '@config';

const types = config.smartAssets.types
  .reduce((state, key) => ({
    ...state,
    [key]: {}
  }), {});

const initialState = {
  userInputs: types,
  definedAssets: types
};

function setAssets (type) {
  return (state, { payload }) => {
    payload.forEach(resource => {
      state[type][resource.type][resource.id] = resource;
    });
  }
}

export default createReducer(initialState, builder => {
  builder
    .addCase(assetsActions.setDefinedAssets, setAssets('definedAssets'))
    .addCase(assetsActions.setUserInputs, setAssets('userInputs'));
});
